export default "__VITE_ASSET__d7aaf6f8__"